import posthog from 'posthog-js/dist/module.full';

/**
 * PostHog links events to session replays via `$session_id`, which its web SDK adds
 * automatically. Our events reach PostHog through Segment instead, so we stamp it on
 * ourselves. https://posthog.com/docs/session-replay/troubleshooting
 *
 * Returns nothing when PostHog is disabled or has not finished loading, so events fired
 * before init still go out - just without replay linkage.
 */
export function getPosthogSessionProps(): { $session_id?: string } {
  try {
    if (!posthog?.__loaded) return {};
    // get_session_id is read-only: it neither starts nor extends a session.
    const sessionId = posthog.get_session_id();
    return sessionId ? { $session_id: sessionId } : {};
  } catch {
    return {};
  }
}
